import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=98046592"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98046592')) {
      api.createRecord('98046592', component.options)
    } else {
      api.reload('98046592', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=98046592", function () {
      api.rerender('98046592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/Profile.vue"
export default component.exports